module.exports = __webpack_public_path__ + "img/22.756b78c2.png";